import { RowMenu, type RowAction } from '../ui/RowMenu';
import { STATE_LABELS, type VersionSummary } from './types';

const shortDate = (iso: string) => new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', day: '2-digit', month: '2-digit' }).format(new Date(iso));

/** "robocza", "wysłana 20.10", "nieaktualna"… */
export function stateText(v: Pick<VersionSummary, 'state' | 'outdated' | 'sentAt'>): string {
  if (v.outdated) return 'nieaktualna';
  if (v.state === 'wyslana' && v.sentAt) return `wysłana ${shortDate(v.sentAt)}`;
  return STATE_LABELS[v.state];
}

/** The versions as a segment ("v1 · v2 · v3", each with its state), the one main action and the rarer ones under "…". */
export function VersionBar({ versions, selectedId, onSelect, primary, secondary, printView, actions }: { versions: VersionSummary[]; selectedId: string; onSelect: (id: string) => void; primary?: RowAction | null; secondary?: RowAction | null; /** wzór F: „Podgląd wydruku” */ printView?: RowAction | null; actions: RowAction[] }) {
  return (
    <div className="q-versionbar" data-feature-id="quotes.versions">
      <div className="segment q-versions" role="group" aria-label="Wersje kosztorysu">
        {versions.map((v) => (
          <button key={v.id} type="button" aria-pressed={v.id === selectedId} onClick={() => onSelect(v.id)}>
            <span className="q-vnum">v{v.number}</span>
            <span className="q-vstate" data-state={v.outdated ? 'nieaktualna' : v.state}>
              {stateText(v)}
            </span>
          </button>
        ))}
      </div>
      <div className="q-versionbar-actions">
        {secondary && (
          <button className="btn" type="button" onClick={secondary.onSelect} data-feature-id="quotes.pdf_preview">
            {secondary.label}
          </button>
        )}
        {printView && (
          <button className="btn" type="button" onClick={printView.onSelect} data-feature-id="quotes.print_view">
            {printView.label}
          </button>
        )}
        {primary && (
          <button className="btn primary" type="button" onClick={primary.onSelect} disabled={primary.disabled} title={primary.title}>
            {primary.label}
          </button>
        )}
        <RowMenu label="Więcej działań kosztorysu" actions={actions} />
      </div>
    </div>
  );
}
